import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import UnavailableDishes from './UnavailableDishes';

import {
  cancelMergeOrder,
  continueWithoutUnavailableDishes,
} from '../../stateManagement/engine/actions/OrderHistoryActions';
import { hideModal } from '../../stateManagement/engine/actions/SessionActions';

function mapStateToProps(state, ownProps) {
  return {
    dishes: state.order.unavailableOrderItems,
    currency: state.session.organization.currency,
    locale: state.session.organization.locale,
    ...ownProps,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    ...bindActionCreators(
      {
        onOkClick: continueWithoutUnavailableDishes,
        onCancelClick: cancelMergeOrder,
        hideModal,
      },
      dispatch,
    ),
    ...ownProps,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UnavailableDishes);
